import { createAction } from 'redux-actions';

export const clearInventoryLocations = createAction(
  'CLEAR_INVENTORY_LOCATIONS'
);

export const updateInventoryLocationZones = createAction(
  'UPDATE_INVENTORY_LOCATION_ZONES'
);

export const removeZoneFromInventoryLocation = createAction(
  'REMOVE_ZONE_FROM_INVENTORY_LOCATION'
);

export const inventoryLocationsOnChangePage = createAction(
  'INVENTORY_LOCATIONS_ON_CHANGE_PAGE'
);

export const inventoryLocationsOnChangeOrder = createAction(
  'INVENTORY_LOCATIONS_ON_CHANGE_ORDER'
);
